import React from 'react';
import {useSelector} from 'react-redux';
import { Collapse, Button } from 'antd';
import stylesRiepilogo from '../Riepilogo.module.scss';
import moment from 'moment';
import Immagine from '../../../../components/Immagine/Immagine';

const { Panel } = Collapse;

const PanelAnagrafici = (props) => {

    const datiSteps = useSelector(state => state.dataReducer.modello.datiPratica);

    return (
        <Collapse expandIcon={({ isActive }) =>  isActive ? <Immagine urlImage={'menus.svg'} name="CLOSE" class={stylesRiepilogo.immagineCollapse} /> : <Immagine urlImage={'plus.svg'} name="OPEN" class={stylesRiepilogo.immagineCollapse} />  }>
            <Panel header={props.headerPanel} key={props.chiave}>
                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Cittadinanza</h3>
                        <Button onClick={() => props.tornaAlloStep(5)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Cittadinanza
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                {
                                    datiSteps.cittadinanza === 'IT' ? 'Italiana' :
                                    datiSteps.cittadinanza === 'EU' ? 'Comunitaria' :
                                    datiSteps.cittadinanza === 'EX' ? 'Extra UE' :
                                    null
                                }
                                </div>
                            </div>

                            {
                                datiSteps.cittadinanza === 'EU' ? (
                                    <>
                                    <div className={stylesRiepilogo.rigaRiepilogo}>
                                        <div className={stylesRiepilogo.leftRiepilogo}>
                                            Permesso di soggiorno
                                        </div>
                                        <div className={stylesRiepilogo.rightRiepilogo}>
                                            {
                                                datiSteps.tipoPermessoSoggiorno === 'PSI' ? 'Permesso indeterminato' :
                                                datiSteps.tipoPermessoSoggiorno === 'PS2' ? 'Permesso determinato 2 anni' :
                                                datiSteps.tipoPermessoSoggiorno === 'PS5' ? 'Permesso determinato 5 anni' :
                                                null
                                            }
                                        </div>
                                    </div>

                                    {
                                        (datiSteps.tipoPermessoSoggiorno === 'PS2' || datiSteps.tipoPermessoSoggiorno === 'PS5') ? (

                                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                                <div className={stylesRiepilogo.leftRiepilogo}>
                                                    Data di scadenza
                                                </div>
                                                <div className={stylesRiepilogo.rightRiepilogo}>
                                                    {moment(datiSteps.dataScadenzaSoggiorno).format('DD/MM/YYYY')}
                                                </div>
                                            </div>

                                        ) : null
                                    }

                                    </>
                                ) : null
                            }
                        </div>
                    </div>

                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Residenza</h3>
                        <Button onClick={() => props.tornaAlloStep(7)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>

                            { datiSteps.abitazione === 'A' ? (

                                <div className={stylesRiepilogo.rigaRiepilogo}>
                                    <div className={stylesRiepilogo.leftRiepilogo}>
                                        Importo Affitto
                                    </div>
                                    <div className={stylesRiepilogo.rightRiepilogo}>
                                        {datiSteps.importoAffitto} €
                                    </div>
                                </div>

                                ) : null
                            }

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                Indirizzo di residenza
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                {datiSteps.indirizzoResidenza}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Numero civico
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.civico}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    CAP
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.cap}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Comune
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.comune}
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Provincia
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.provincia}
                                </div>
                            </div>

                            {datiSteps.indirizzoResidenzaPrecedente !== null && datiSteps.indirizzoResidenzaPrecedente !== '' ? (
                                        <>
                                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                                <div className={stylesRiepilogo.leftRiepilogo}>
                                                    Indirizzo di residenza precedente
                                                </div>
                                                <div className={stylesRiepilogo.rightRiepilogo}>
                                                    {datiSteps.indirizzoResidenzaPrecedente}
                                                </div>
                                            </div>

                                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                                <div className={stylesRiepilogo.leftRiepilogo}>
                                                    Numero civico
                                                </div>
                                                <div className={stylesRiepilogo.rightRiepilogo}>
                                                    {datiSteps.civicoPrecedente}
                                                </div>
                                            </div>

                                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                                <div className={stylesRiepilogo.leftRiepilogo}>
                                                    CAP
                                                </div>
                                                <div className={stylesRiepilogo.rightRiepilogo}>
                                                    {datiSteps.capPrecedente}
                                                </div>
                                            </div>

                                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                                <div className={stylesRiepilogo.leftRiepilogo}>
                                                    Comune
                                                </div>
                                                <div className={stylesRiepilogo.rightRiepilogo}>
                                                    {datiSteps.comunePrecedente}
                                                </div>
                                            </div>

                                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                                <div className={stylesRiepilogo.leftRiepilogo}>
                                                    Provincia
                                                </div>
                                                <div className={stylesRiepilogo.rightRiepilogo}>
                                                    {datiSteps.provinciaPrecedente}
                                                </div>
                                            </div>
                                        </>
                            ) : null
                            }

                        </div>
                    </div>


                            <div className={stylesRiepilogo.Riepilogo}>
                                <h3 className={stylesRiepilogo.titoloRiepilogo}>Documento di riconoscimento</h3>
                                <Button onClick={() => props.tornaAlloStep(8)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                                <div className={stylesRiepilogo.tabellaRiepilogo}>

                                    <div className={stylesRiepilogo.rigaRiepilogo}>
                                        <div className={stylesRiepilogo.leftRiepilogo}>
                                        Tipo documento
                                        </div>
                                        <div className={stylesRiepilogo.rightRiepilogo}>
                                            {
                                                datiSteps.documento === '01' ? "Carta d'identità" :
                                                datiSteps.documento === '02' ? 'Patente' :
                                                datiSteps.documento === '03' ? 'Passaporto italiano' :
                                                null
                                            }
                                        </div>
                                    </div>

                                    <div className={stylesRiepilogo.rigaRiepilogo}>
                                        <div className={stylesRiepilogo.leftRiepilogo}>
                                            Numero documento
                                        </div>
                                        <div className={stylesRiepilogo.rightRiepilogo}>
                                            {datiSteps.numeroDocumento}
                                        </div>
                                    </div>

                                    <div className={stylesRiepilogo.rigaRiepilogo}>
                                        <div className={stylesRiepilogo.leftRiepilogo}>
                                            Data di rilascio
                                        </div>
                                        <div className={stylesRiepilogo.rightRiepilogo}>
                                            {moment(datiSteps.dataEmissioneDocumento).format('DD/MM/YYYY')}
                                        </div>
                                    </div>

                                    <div className={stylesRiepilogo.rigaRiepilogo}>
                                        <div className={stylesRiepilogo.leftRiepilogo}>
                                            Provincia emissione
                                        </div>
                                        <div className={stylesRiepilogo.rightRiepilogo}>
                                            {datiSteps.comuneEmissione}
                                        </div>
                                    </div>

                                    <div className={stylesRiepilogo.rigaRiepilogo}>
                                        <div className={stylesRiepilogo.leftRiepilogo}>
                                            Comune emissione
                                        </div>
                                        <div className={stylesRiepilogo.rightRiepilogo}>
                                            {datiSteps.provinciaEmissione}
                                        </div>
                                    </div>
                                </div>
                            </div>

                </Panel>
        </Collapse>
    )
}

export default PanelAnagrafici;